module.exports = __webpack_public_path__ + "static/img/2.eb057fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/2.png
// module id = 4DX8
// module chunks = 0